export const MAIN_FORM_STATE_KEY = "online-application-frontend-form-state";
